export const gearCouplingSF = {
    safetyFactor: 2.0,
    driveFactor: 1.2,
}

export const gearCouplingData = [       // 출처 : Nara Corporation (Korea)
    {
        type: 'SSM',
        rating: 100,
        model: 'SSM100',
        allowableTorque: 421,           // N-m
        maxRPM: 5000,
        weight: 2.9,
        inertia: 0.003,                 // kg-m2
    },
    {
        type: 'SSM',
        rating: 112,
        model: 'SSM112',
        allowableTorque: 788,
        maxRPM: 5000,
        weight: 4.1,
        inertia: 0.005,
    },
    {
        type: 'SSM',
        rating: 125,
        model: 'SSM125',
        allowableTorque: 1400,
        maxRPM: 5000,
        weight: 5.8,
        inertia: 0.008,
    },
    {
        type: 'SSM',
        rating: 140,
        model: 'SSM140',
        allowableTorque: 2010,
        maxRPM: 5000,
        weight: 8.8,
        inertia: 0.015,
    },
    {
        type: 'SSM',
        rating: 160,
        model: 'SSM160',
        allowableTorque: 3080,
        maxRPM: 5000,
        weight: 14.0,
        inertia: 0.030,
    },
    {
        type: 'SSM',
        rating: 180,
        model: 'SSM180',
        allowableTorque: 4730,
        maxRPM: 5000,
        weight: 19.0,
        inertia: 0.050,
    },
    {
        type: 'SSM',
        rating: 200,
        model: 'SSM200',
        allowableTorque: 6750,
        maxRPM: 4700,
        weight: 26.0,
        inertia: 0.080,
    },
    {
        type: 'SSM',
        rating: 224,
        model: 'SSM224',
        allowableTorque: 9810,
        maxRPM: 4200,
        weight: 40.0,
        inertia: 0.160,
    },
    {
        type: 'SSM',
        rating: 250,
        model: 'SSM250',
        allowableTorque: 14400,
        maxRPM: 3800,
        weight: 56.0,
        inertia: 0.290,
    },
    {
        type: 'SSM',
        rating: 280,
        model: 'SSM280',
        allowableTorque: 22900,
        maxRPM: 3400,
        weight: 79.0,
        inertia: 0.500,
    },
    {
        type: 'SSM',
        rating: 315,
        model: 'SSM315',
        allowableTorque: 36100,
        maxRPM: 3000,
        weight: 122.0,
        inertia: 1.010,
    },
    {
        type: 'SSM',
        rating: 355,
        model: 'SSM355',
        allowableTorque: 54400,
        maxRPM: 2600,
        weight: 171.0,
        inertia: 1.770,
    },
    {
        type: 'SSM',
        rating: 400,
        model: 'SSM400',
        allowableTorque: 76400,
        maxRPM: 2300,
        weight: 245.0,
        inertia: 3.25,
    },
    {
        type: 'CCM',
        rating: 450,
        model: 'CCM450',
        allowableTorque: 93000,
        maxRPM: 2100,
        weight: 300.0,
        inertia: 5.10,
    },
    {
        type: 'CCM',
        rating: 500,
        model: 'CCM500',
        allowableTorque: 127000,
        maxRPM: 1900,
        weight: 429.0,
        inertia: 9.10,
    },
    {
        type: 'CCM',
        rating: 560,
        model: 'CCM560',
        allowableTorque: 204000,
        maxRPM: 1700,
        weight: 619.0,
        inertia: 16.90,
    },
    {
        type: 'CCM',
        rating: 630,
        model: 'CCM630',
        allowableTorque: 309000,
        maxRPM: 1500,
        weight: 921.0,
        inertia: 32.40,
    },
    {
        type: 'CCM',
        rating: 710,
        model: 'CCM710',
        allowableTorque: 450000,
        maxRPM: 1300,
        weight: 1312.0,
        inertia: 59.90,
    },
    {
        type: 'CCM',
        rating: 800,
        model: 'CCM800',
        allowableTorque: 643000,
        maxRPM: 1150,
        weight: 1830.0,
        inertia: 102.0,
    },
    {
        type: 'CCM',
        rating: 900,
        model: 'CCM900',
        allowableTorque: 915000,
        maxRPM: 1050,
        weight: 2753.0,
        inertia: 200.0,
    },
    {
        type: 'CCM',
        rating: 1000,
        model: 'CCM1000',
        allowableTorque: 1254000,
        maxRPM: 950,
        weight: 3700.0,
        inertia: 322.0,
    },
    {
        type: 'CCM',
        rating: 1120,
        model: 'CCM1120',
        allowableTorque: 1764000,
        maxRPM: 850,
        weight: 5402.0,
        inertia: 622.0,
    },
    {
        type: 'CCM',
        rating: 1250,
        model: 'CCM1250',
        allowableTorque: 2450000,
        maxRPM: 750,
        weight: 7730.0,
        inertia: 1129.0,
    },
];

// export const selectGearCoupling = (value) => {
//     if (isNaN(value)) {
//         return null;
//     }
//     const requiredTorque = parseFloat(value);
    
//     for (const coupling of gearCouplingData) {
//         const allowableTorque = parseFloat(coupling.allowableTorque);
//         console.log('required Torque : ', requiredTorque);
//         console.log('allowable Torque : ', allowableTorque);
//         if (allowableTorque > requiredTorque) {
//             return coupling.allowableTorque;
//         }
//     }
//     return null;
// }

export const selectGearCoupling = (value) => {
    if (isNaN(value)) return null;

    const selected = gearCouplingData.find(obj => obj.allowableTorque >= Number(value));

    if (!selected) {
        return null;
    }

    return selected;
}
